// extracted by mini-css-extract-plugin
module.exports = {"info":"image-slide_info_3-z-I","slide":"image-slide_slide_12uO7","image":"image-slide_image_XgKt3"};